import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc, querySetting } from 'keys/queryClient'
import { getInterventionProfilesFetch } from 'store/middlewares/assessment.crud'

// נתוני התערבויות לעמוד "צמצום פערים בקריאה - מענים"
// מחזיר לכל דירוג את כמות תלמידים בכל תוכנית התערבות
const useSlide6InterventionData = (assessmentFilters) => {
    const semesterAndYear = assessmentFilters?.semester_and_year

    const { data, isLoading, isError, error } = useQuery({
        queryKey: [qc.interventionProfiles, JSON.stringify(semesterAndYear)],
        queryFn: async ({ signal }) => {
            const result = await getInterventionProfilesFetch(assessmentFilters, signal)
            return result?.data
        },
        ...querySetting,
        enabled: !!semesterAndYear,
        staleTime: 0
    })

    return useMemo(() => ({
        interventionData: data || {},
        isLoading,
        isError,
        error
    }), [data, isLoading, isError, error])
}

export default useSlide6InterventionData
